import { useCallback, useState } from 'react';

// Create a singleton instance to store the data across components
let lastSecondsAccruedValue: number | undefined;
let totalCommitmentLengthValue: number | undefined;

export const useCommitmentTimeData = () => {
  // Get the current values
  const [lastSecondsAccrued, setLastSecondsAccrued] = useState<
    number | undefined
  >(lastSecondsAccruedValue);
  const [totalCommitmentLength, setTotalCommitmentLength] = useState<
    number | undefined
  >(totalCommitmentLengthValue);
  // Update both the local state and the singleton values
  const updateTimeData = useCallback(
    (newLastSecondsAccrued?: number, newTotalCommitmentLength?: number) => {
      // Update singleton values
      lastSecondsAccruedValue = newLastSecondsAccrued;
      totalCommitmentLengthValue = newTotalCommitmentLength;

      // Update local state
      setLastSecondsAccrued(newLastSecondsAccrued);
      setTotalCommitmentLength(newTotalCommitmentLength);
    },
    []
  );

  // Extract time data from API response
  const extractCommitmentTimeData = useCallback(
    (result: any) => {
      if (result && 'data' in result) {
        const { last_seconds_accrued, total_commitment_length } = result.data
          .action.data as {
          last_seconds_accrued?: number;
          total_commitment_length?: number;
        };

        // Update the time data
        updateTimeData(last_seconds_accrued, total_commitment_length);

        return { last_seconds_accrued, total_commitment_length };
      }
      return {
        last_seconds_accrued: undefined,
        total_commitment_length: undefined,
      };
    },
    [updateTimeData]
  );

  return {
    lastSecondsAccrued,
    totalCommitmentLength,
    updateTimeData,
    extractCommitmentTimeData,
  };
};
